import React from 'react'
import { ConnectedRouter } from 'connected-react-router'
import { Redirect, Route, Switch } from 'react-router-dom'

import ApplicationLayout from './layouts'
import getPageRoutes, { TPageProps } from 'App/util/appRoutes'
import defaultPages from '../common/pages'
import NotFoundPage from 'App/pages/404'

export type TRouterProps = {
  indexUrl: string
  pages: TPageProps[]
  history?: any
}

const HootsuiteStreamRouter = ({ indexUrl, history, pages }: TRouterProps) => {
  const pageRoutes = getPageRoutes([...pages, ...defaultPages])
  return (
    <ConnectedRouter history={history}>
      <ApplicationLayout>
        <Switch>
          <Route exact path="/" render={() => <Redirect to={indexUrl} />} />
          {pageRoutes}
          <Route component={NotFoundPage.routeProps.component} />
        </Switch>
      </ApplicationLayout>
    </ConnectedRouter>
  )
}

export default HootsuiteStreamRouter
